const resources = {
    popularOffers: 'Popular Offers',
    signIn: 'Sign In',
    signInSubtitle: 'to unlock exclusive offers'
};

export default function getResource(label) {
    return resources[label];
}
